export default __webpack_public_path__ + "static/media/hours.ec7c6704.png";